import Manager from "../../src/manager";
import React from "react";
import Functions from "../../src/functions";

function Mapper(data, status, response, error, component) {
	let output = [];
	let landPageData = JSON.parse(sessionStorage.landPageData);
	let UserType = Functions["custom"]["getUserType"]();
	if (UserType !== "HYBRID_BUSINESS_COST_CONTROL") {
		sessionStorage.setItem(
			"amount",
			landPageData.mobileTaxExempted
				? data.tarrifWithoutVat
				: data.tarrifWithVat,
		);
	} else {
		let modal = JSON.parse(sessionStorage.modalData).modal;
		sessionStorage.setItem(
			"amount",
			landPageData.mobileTaxExempted ? modal.tariff : modal.tariffWithCreditVat,
		);
	}
	sessionStorage.setItem("rli", data.rli);
	let property = {};
	property["showTerms"] = data;
	property["serviceId"] = data.serviceId;
	output.push(property);

	return output;
}

function Properties(args) {
	let editable = args.editable ? true : false;
	return {
		header: {
			alias: "header",
			type: "module",
			configuration: {
				module: "header",
				view: "list",
			},
			editable,
		},
		serviceId: {
			alias: "serviceId",
			type: "text",
		},
		footer: {
			alias: "footer",
			type: "module",
			configuration: {
				module: "footer",
				view: "list",
			},
			editable,
		},
		main: {
			alias: "main",
			type: "module",
			configuration: {
				module: "cosmoteAvailableContracts",
				view: "list",
			},
			editable,
		},
		showTerms: {
			alias: "showTerms",
			type: "text",
			label: "",
			placeholder: "",
			useCustomUI: true,
			customUI: function () {
				let data = this.props.data;
				let _this = this;
				return (
					<a
						className="open-lightbox"
						style={{ cursor: "pointer" }}
						onClick={(e) => clickMeTerm(_this)}>
						όρους χρήσης
					</a>
				);
			},
		},
	};
}

function clickMeTerm(_this) {
	let id = _this.props.primaryKey;
	let manager = _this.props.manager;
	window["modal"].setState({
		// title: <h4>Confirm deletion</h4>,
		targetComponent: this,
		show: true,
		callback: function (args) {
			window["modal"].setState({ show: false });
			setTimeout(manager.refresh, 2000);
		},
		// footer: [],
		body: (
			<Manager
				key="modalForCredit"
				module="modalForCredit"
				data={_this.props.data}
				view="list"
				ref={(refComponent) => {
					window["modalbody"] = refComponent;
				}}></Manager>
		),
	});
}

const SubmitPaymentInfo = {
	auth: "",
	views: {
		list: {
			apis: {
				view: {
					url: "{path}",
					method: "{method}",
					postData: function () {
						return {
							rli: sessionStorage.getItem("rli"),
							t: Math.random(),
							id: sessionStorage.getItem("id"),
							groupId: sessionStorage.getItem("groupId"),
						};
					},
					replace: {
						method: function () {
							let UserType = Functions["custom"]["getUserType"]();
							if (UserType === "HYBRID_BUSINESS_COST_CONTROL") {
								return "GET";
							} else {
								return "POST";
							}
						},
						path: function () {
							let random = new Date().getTime();

							let UserType = Functions["custom"]["getUserType"]();
							if (UserType === "HYBRID_BUSINESS_COST_CONTROL") {
								return (
									"/page/submitPaymentInfo?rli=" + sessionStorage.getItem("rli")
								);
							} else {
								return (
									"/page/submitPaymentInfo?t=" +
									random +
									"&rli=" +
									sessionStorage.getItem("rli")
								);
							}
						},
					},
					headers: {
						"Content-Type": "application/json",
					},
					mapper: Mapper,
				},
			},
			template: "submitPaymentInfo",
			templateConfiguration: {
				includeProperties: ["none"],
				excludeProperties: [],
				events: { onClick: function (e) {} },
			},
			properties: Properties({ editable: false }),
			primaryKey: "id",
		},
	},
};

export default SubmitPaymentInfo;
